import { render, staticRenderFns } from "./ComplexBuildingList.vue?vue&type=template&id=2747d5d0&scoped=true"
import script from "./ComplexBuildingList.vue?vue&type=script&lang=js"
export * from "./ComplexBuildingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2747d5d0",
  null
  
)

export default component.exports